/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface BvConnectedItemSignature {
  Args: {
    focused?: boolean;
    /**
     * The position of the item.
     */
    position?: 'left' | 'right' | 'primary';
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default class BvConnectedItemComponent extends Component<BvConnectedItemSignature> {
  /**
   * Whether or not the item is focused.
   *
   * @property focused
   * @private
   * @type {Boolean}
   * @default false
   */
  @tracked focused: boolean = this.args.focused ?? false;

  @action
  handleFocusIn() {
    this.focused = true;
  }

  @action
  handleFocusOut() {
    this.focused = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvConnected::Item': typeof BvConnectedItemComponent;
    'bv-connected/item': typeof BvConnectedItemComponent;
  }
}
